// Checkify override: forcing upsell modal window's "Checkout Now" button to go to Checkify
(function () {
  const simulateCheckifyCheckout = () => {
    const checkifyBtn = document.querySelector('button[data-checkify="true"]');
    if (checkifyBtn) {
      console.log('[Checkify Override] Triggering native Checkify button click');
      checkifyBtn.click();
    } else {
      console.warn('[Checkify Override] No Checkify button found on page');
    }
  };

  const overrideUpsellButton = () => {
    const upsellBtn = document.querySelector('#upsell-popup-continue-button');
    if (upsellBtn && !upsellBtn.dataset.checkifyAttached) {
      upsellBtn.dataset.checkifyAttached = 'true';
      console.log('[Checkify Override] Attached to upsell popup button');
      upsellBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        simulateCheckifyCheckout();
      }, { once: true });
    }
  };

  const observer = new MutationObserver(() => {
    overrideUpsellButton();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  overrideUpsellButton();
})();

// only allowing add to cart button to be clicked once per page load
(function () {
  const observeAddToCartButton = () => {
    const btn = document.querySelector('.product-form__submit.button--full-width.button--primary');

    if (btn && !btn.dataset.onceClickedBound) {
      btn.dataset.onceClickedBound = 'true';
      btn.addEventListener('click', function () {
        btn.classList.add('clicked-once');
      }, { once: true });
    }
  };

  const observer = new MutationObserver(observeAddToCartButton);

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Also run immediately in case it's already there
  document.addEventListener('DOMContentLoaded', observeAddToCartButton);
})();